import { AlertCircleIcon, CheckIcon, CopyIcon } from "lucide-react";
import { useState } from "react";

/**
 * A failed run's error, verbatim and copyable.
 *
 * Verbatim matters: the message is the worker's, and someone debugging an
 * ingestion failure needs the exact text to match against its logs — a
 * friendlier paraphrase would cost them the only identifier they have.
 */
export function DocumentStatusAlert({ error }: { error: string | null }) {
  const [copied, setCopied] = useState(false);

  if (!error) return null;

  return (
    <div className="rounded-lg border border-destructive/20 bg-destructive/5">
      <div className="flex items-start gap-3 p-4">
        <span className="flex size-7 shrink-0 items-center justify-center rounded-md bg-destructive/10">
          <AlertCircleIcon className="size-4 text-destructive" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <h2 className="text-sm font-semibold text-destructive">Processing failed</h2>
            <button
              type="button"
              title="Copy error"
              aria-label="Copy error"
              className="shrink-0 cursor-pointer rounded-md p-1 text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
              onClick={() => {
                void navigator.clipboard
                  .writeText(error)
                  .then(() => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), 1_500);
                  })
                  .catch(() => setCopied(false));
              }}
            >
              {copied ? <CheckIcon className="size-3.5" /> : <CopyIcon className="size-3.5" />}
            </button>
          </div>
          <p className="mt-1 text-sm leading-relaxed text-foreground/70">{error}</p>
        </div>
      </div>
    </div>
  );
}
